import { ParsedQs } from 'qs';

/* function removes sensitive data token from url*/
export const getURLForSampling = (queryParams: ParsedQs) => {
  const urlForSampling = new URL(window.location.href);
  urlForSampling.search = '';

  const paramsForSampling = { ...queryParams };

  // delete sensitive data token
  delete paramsForSampling.token;

  Object.entries(paramsForSampling).forEach(([key, value]) => {
    if (value) {
      urlForSampling.searchParams.append(key, value.toString());
    }
  });

  return urlForSampling.toString();
};
